import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Get } from "../../../../../Request";
import { GenderRender, ToDateJalali } from "../../../Function";
export const useReserves = () => {
  const [loading, setLoading] = useState({
    list: true,
  });
  let { inint } = useParams();

  const [data, setData] = useState({});
  const getResrves = async data => {
    setLoading({ ...loading, list: true });

    let obj = { timekey: inint.split("-")[0] };
    if (inint.split("-").length > 1) {
      obj.daykey = inint.split("-")[1];
      obj.item_id = inint.split("-")[2];
    }
    await Get({
      url: "/reserve/get_reserve_with_time",
      data: { ...obj, ...data },
    }).then(response => {
      if (response) {
        setData(response);
      }
      setLoading({ ...loading, list: false });
    });
  };
  const renderTime = () => {
    if (data.data && data.data[0] && data.data[0].reserve_details) {
      const { reserve_details, reserve_time } = data.data[0];
      if (reserve_details.title && !reserve_time.date) {
        let gender = reserve_details.gender;
        if (gender) {
          gender = "- " + GenderRender(reserve_details.gender);
        }
        else {
          gender = ""
        }
        return `رزرو های شیفت ${reserve_details.title} - ${reserve_time.start
          } تا ${reserve_time.end} ${gender}`;
      }
      else if (reserve_details.title && reserve_time.date) {
        return `رزرو های شیفت ${reserve_details.title} - ${reserve_time.start
          } تا ${reserve_time.end} - ${ToDateJalali(
            reserve_time.date
          )} - ${GenderRender(reserve_details.gender)}`;
      }
      else {
        return `رزرو های سانس ${reserve_time.start} تا ${reserve_time.end
          } - ${ToDateJalali(reserve_time.date)} - ${GenderRender(
            reserve_details.gender
          )}`;
      }
    } else {
      return "شیفت یافت نشد";
    }
  };
  const paginate = page => {
    getResrves({ page });
  };
  return { getResrves, data, loading, renderTime, paginate };
};
